import { getLinkToUnblockPushNotifications } from "src/containers/facilityUser/modifyUser/notificationInput";
import { Link } from "../../designsystem/Link/Link";
import { INotification } from "src/modules/myAccount/types";

export function NotificationBlockedMessage({ notification }: { notification: INotification }) {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { braze } = window as any;
  const pushBlocked = braze.isPushBlocked();
  const linkToUnblockPushNotifications = getLinkToUnblockPushNotifications();

  if (!(pushBlocked && notification.push)) {
    return null;
  }
  return (
    <Link target="_blank" href={linkToUnblockPushNotifications.link} style={{ color: "#032E68" }}>
      {" - "}
      <span>{linkToUnblockPushNotifications.text}</span>
    </Link>
  );
}
